<template>
  <div>
    <ProductNotificationMessage @modal-open="modalOpen()"></ProductNotificationMessage>
    <transition name="modal">
      <modal v-if="showModal" @modal-close="modalClose()" modal-type="alt" is-close="true">
        <template v-if="isLogged">
            <ModalProductNotification @modal-close="modalClose"></ModalProductNotification>
        </template>
        <template v-else>
            <ModalProductNotification @modal-close="modalClose" is-form></ModalProductNotification>
        </template>
      </modal>
    </transition>
  </div>
</template>
<script>

import { trinyConfig } from '@/config'

import Modal from '@/components/Modal.vue'
import ModalProductNotification from '@/components/ProductNotification/ProductNotificationModalSave.vue'
import ProductNotificationMessage from '@/components/ProductNotification/ProductNotificationMessage.vue'
import { bindClickEventWithPreventDefault } from '@/shared'

export default {
  components: {
    Modal,
    ModalProductNotification,
    ProductNotificationMessage
  },

  data () {
    return {
      notificationConfig: {},
      showModal: false,
      isLogged: false
    }
  },

  created () {
    bindClickEventWithPreventDefault(document, '.js-notification-open', (options) => {
      this.modalOpen()
    })
  },

  mounted () {
    this.isLogged = trinyConfig.logged
  },

  methods: {
    modalOpen () {
      event.preventDefault()

      this.showModal = true
    },

    modalClose () {
      this.showModal = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProductNotification/ProductNotification.vue